module.exports = __webpack_public_path__ + "img/06-0小图.bd790bb3.png";